// extracted by mini-css-extract-plugin
export default {"mCard":"DC-z","image":"EC-z","imageNoBackground":"FC-z","imageHasCategory":"GC-z","fullWidth":"HC-z"};